import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { 
  IInventoryMovement, 
  IInventoryMovementFilters 
} from '../models/IInventoryMovement/IInventoryMovement';
import { API_BASE_URL } from '../helpers/common';
import { IPaginationResponse } from '../interfaces/responces/IPagination.response';
import { IFilter } from 'interfaces/IFilter';

export const inventoryMovementsApi = createApi({
  reducerPath: 'inventoryMovementsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      token && headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getInventoryMovements: build.query<
      IPaginationResponse<IInventoryMovement>,
      IFilter
    >({
      transformResponse: (response: {
        data: IPaginationResponse<IInventoryMovement>;
      }) => response.data,
      query: (params) => ({
        url: '/inventory-logs/list',
        method: 'GET',
        params
      }),
    }),
    getInventoryMovementById: build.query<IInventoryMovement, number>({
      transformResponse: (response: { data: IInventoryMovement }) =>
        response.data,
      query: (id) => ({
        url: `/inventory-logs/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetInventoryMovementsQuery,
  useGetInventoryMovementByIdQuery,
} = inventoryMovementsApi;
